export const LIVE_OFFSET_IN_SECONDS = 5;
export const SKIPPING_STEP_IN_SECONDS = 10;
